import styled from 'styled-components';

const OrderDetail = styled.div`
  border-top: solid 1px #97979729;
  padding: 20px 0;
  
  Button {
    background: #61b01f; 
    background: -moz-linear-gradient(top, #61b01f 0%, #27911b 100%); 
    background: -webkit-linear-gradient(top, #61b01f 0%,#27911b 100%); 
    background: linear-gradient(to bottom, #61b01f 0%,#27911b 100%); 
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#61b01f', endColorstr='#27911b',GradientType=0 );
    border-radius: 5px;
    color: $white;
    border-width: 2px;
    height: 36px;
    font-size: 17px;
    font-family: 'latobold';
    border:none;
    max-width: 161px;
    margin: 30px 0 20px auto;
    width: 100%;
  }
  .app-input-text{
    margin-bottom: 0px;
    textarea{
      height: 63px !important;
    }
  }
  .invalidPromoCodeStyle .app-input-text input{
    border: solid 1px red;
    color: red;
  }
  .checkout-count-table{
    position: relative;
  }
  .checkout-count-table small.text-muted{
    font-size: 11px;
    white-space: nowrap;
  }
  @media(max-width: 767px){
    .checkout-total, .checkout-product-detail{
      display: block;
    }
    .checkout-product-desc{
      margin: 20px 0;
    }
    .checkout-count-table p{
      grid-gap: 2px;
    }
  }
  @media (max-width: 465px){
    .checkout-count-table small.text-muted{
      /* bottom: 68%; */
    }
  }
`;
const Container = styled.div`
  max-width: 1411px;
  width: 100%;
  margin: 0 auto;
  padding: 0 85px;
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
`;

const Wrapper = styled.div`
`;
const Section = styled.div`
display: grid;
grid-gap: 5px;
grid-template-columns: 217px 1fr;
.offer-amt-styles{
  display: flex;
  margin-top: 26px;
  align-items: baseline;
  h6{
    font-size: 17px;
    font-family: latobold;
    margin-right: 12px;
  }
  .app-input-text{
    margin-bottom: 0px !important;
    input{
      max-width: 125px;
    }
  }
}
  @media only screen and (max-width: 1250px) {
    grid-template-columns: 1fr;
  }
  @media only screen and (max-width: 970px) {
    flex-direction: column;
  }
  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;
const PayWith = styled.div`
  
`;
const ReviewOrder = styled.div`
  background-color: #ffffff;
  padding: 0;
  min-width: 338px;
  @media only screen and (max-width: 970px) {
    width: 100%;
    min-width:auto;
  }
`;
const Heading = styled.div`
  font-size: 17px;
  color: #000000;
  line-height: 25px;
  font-family: 'latobold';
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  Button {
    color: #00b3ff;
    background: #ffffff;
    font-size: 20px;
  }
`;
const AccountSection = styled.div`
  display: flex;
  border: 1px solid #e0e0e0;
  padding: 10px 15px;
`;
const AccountType = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .radioField{
    height: 50px !important;
    span{
      font-size: 15px;
      @media (max-width: 465px){
        font-size: 13px;
      }
    }
  }
  .ach-wrapper{
    position: relative;
    left: 2px;
    width: 500px;
    @media (max-width: 725px) {
      max-width: 310px;
    }
    @media (max-width: 420px) {
      max-width: 240px;
    }
  }
  > div {
    > div {
      display: flex;
      > div {
        flex: 1;
        &:first-child {

          > div > div > div > div {
            display: flex;
            flex-direction: column;
            margin: 0 !important;
            > div {
              min-height: 40px;
              display: flex;
              align-items: center;
              .radio-label {
                color: black !important;
                margin: 0;
              }
            }
          }
        }
        &:nth-child(2) {
          max-width: 400px;
          padding-left: 38px;
          > div > div {
            .radio-label {
            }           
          }
          .payment {
            label {
              font-size: 16px;
              color: #212529;
              letter-spacing: normal;
              .StripeElement,
              input {
                border: solid 1px #dddddd;
              }
            }
            Button {
              height: 36px;
            }
          }
        }
      }
      @media only screen and (max-width: 725px) {
        flex-direction: column;
        > div {
          flex: 1;
          &:first-child {
            max-width: 100%;
            border: none;
            > div > div > div > div {
              flex-direction: row;
            }
          }
          &:nth-child(2) {
            max-width: 100%;
            padding-left: 0;
          }
        }
      }
    }
  }
 
`;
const AccountDetail = styled.div``;

const Location = styled.div`
  padding-left: 0;
  .buyer-comment{
    display: flex;
    font-size: 14px;
    align-items: baseline;
    word-break: break-all;
    span{
      font-family: 'latobold';
      margin-right: 5px;
      font-size: 15px;
      white-space: nowrap;
    }
  }
`;
const Address = styled.div`
  padding: 15px;
  border: 1px solid #e0e0e0;
  h2 {
    font-size: 22px;
    margin: 0;
    color: #000000;
    padding: 2px 0;
  }
  p {
    margin: 0;
  }
  .discalimerStyle{
    font-size: 13px;
    margin-top: 7px;
    font-style: italic;
    font-weight: bold;
    font-family: 'latoregular';
  }
`;
export const RequestPickUpAddressStyle = styled.div`
  padding: 10px 15px;
  box-shadow: 0px 2px 10px 0px #00000029;
  border-radius: 5px;
  input{
    width: 100%;
    height: 37px;
    padding: 14px;
    border: 1px solid #87CDF1;
    border-radius: 4px;
    &:disabled {
      background-color: #f0f0f0;
    }
  }
  .firstRow, .secondRow, .thirdRow{
    display: grid;
    gap: 20px;
  }
  .firstRow{
    grid-template-columns: 1fr;
  }
  .secondRow{
    grid-template-columns: 1fr;
  }
  .thirdRow{
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const TendorDetailsWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    margin-top: 20px;
    justify-content: space-between;
    p{
      font-family: 'latobold';
    }
    input{
      width: 100%;
      height: 37px;
      padding: 14px;
      border: 1px solid #87CDF1;
      border-radius: 4px;
      &:disabled {
        background-color: #f0f0f0;
      }
    }
    .pickup-window-calss{
      display: flex;
      gap: 10px;
    }
`
export const Footerstyle = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    button{
      height: 37px;
      width: 100px;
      border-radius: 4px;
      border: none;
      color: #fff;
      background: linear-gradient(180deg, #61B01F 0%, #27911B 100%); 
      &:disabled {
        opacity: 0.5;
      }
    }
`

const Lots = styled.div`
  color: #c30707;
  display: inline-flex;
`;
const DateTimeWrapper = styled.div`
  /* display: flex;
  gap: 30px; */
  display: grid;
    /* grid-template-columns: 1fr 2fr 1fr; */
    grid-template-columns: 1fr 1fr;
    grid-gap: 0 30px;
  .app-input-text {
    margin-bottom: 0;
  }
  @media only screen and (max-width: 575px) {
    flex-direction: column;
  }
`;
const DateTimeWrapper1 = styled.div`
  display: grid;
  grid-gap: 0 30px;
  .recurrenceWrapper{
    font-size: 20px;
    color: #000000;
    line-height: 25px;
    font-family: 'latobold';
    margin-top: 20px;
  }
  @media only screen and (max-width: 575px) {
    flex-direction: column;
  }
`;

const To = styled.div`
  margin: 0 10px;
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 37px;
  padding: 14px;
  border-radius: 5px;
  border: solid 1px #dadada;
  background-color: #ffffff;
  width:100%;
`;

const DateTime = styled.div``;
const ReviewFooter = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  button{
    margin: 10px 0 0px auto;
  }
`;
const Des = styled.div`  
word-break: break-all;
font-family: 'latomedium';
`;

const CommentSection = styled.div`
    background-color: #d8d8d833;
    border-radius: 8px;
    padding: 5px;
    margin-top: 10px;
  > div{
    align-items: baseline;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 10px;
    > h3 {
    font-family: 'latobold';
    font-size: 19px;
    min-width: 115px;
    padding: 12px 0;
    display: flex;
    word-break: keep-all;
    justify-content: space-around;
  }
  p {
    margin: 0;
    word-break: break-all;
  }
  }
`
export {
  DateTimeWrapper,
  DateTimeWrapper1,
  InputWrapper,
  OrderDetail,
  Container,
  Wrapper,
  Section,
  PayWith,
  Address,
  ReviewOrder,
  Heading,
  AccountSection,
  AccountType,
  AccountDetail,
  Location,
  DateTime,
  Lots,
  To,
  ReviewFooter,
  Des,
  CommentSection,
};
